
(function () {
  "use strict";
  function formatMoney(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  }
  function validWhatsApp(value) {
    var number = (value || "").replace(/\D/g, "");
    return /^\d{8,15}$/.test(number) ? number : "";
  }
  function whatsAppHref(number, text) {
    return "https://wa.me/" + number + "?text=" + encodeURIComponent(text);
  }
  function setupTrade(el) {
    if (el.dataset.mzInitialized) return;
    el.dataset.mzInitialized = "1";
    var steps = Array.from(el.querySelectorAll("[data-mz-step]"));
    var bars = el.querySelectorAll(".mz-trade-progress span");
    var form = el.querySelector("form");
    var get = function (field) { return el.querySelector('[data-ti="' + field + '"]'); };
    var selected = function (field) { var radio = el.querySelector('input[data-ti="' + field + '"]:checked'); return radio ? radio.value : ""; };
    var step = 0;
    var sku = "MZ-TI-" + Date.now().toString(36).toUpperCase() + "-" + Math.random().toString(36).slice(2, 6).toUpperCase();
    function showStep(n) {
      step = n;
      steps.forEach(function (item, i) { item.hidden = i !== step; });
      bars.forEach(function (b, i) { b.classList.toggle("is-active", i <= step); });
      var error = steps[step].querySelector("[data-mz-error]");
      if (error) error.hidden = true;
      var focus = steps[step].querySelector("h3");
      if (focus) { focus.tabIndex = -1; focus.focus({ preventScroll: true }); }
    }
    function error(message) {
      var elError = steps[step].querySelector("[data-mz-error]");
      if (elError) { elError.textContent = message; elError.hidden = false; }
    }
    function getEstimate() {
      var lines = (el.dataset.rates || "").split(/\r?\n/);
      var normalize = function (x) { return (x || "").trim().toLowerCase().replace(/\s+/g, " "); };
      var key = [get("category").value, get("brand").value, get("model").value, get("storage").value].map(normalize).join("|");
      var rate = null;
      lines.forEach(function (line) {
        var parts = line.split("|");
        if (parts.length !== 5) return;
        if (parts.slice(0, 4).map(normalize).join("|") !== key) return;
        var amount = Number(parts[4].trim());
        if (Number.isFinite(amount) && amount > 0) rate = amount;
      });
      if (rate == null) return null;
      var factor = selected("powers") === "Yes" ? 1 : 0.45;
      if (selected("cracks") !== "Yes") factor *= 0.7;
      if (selected("battery") !== "Yes") factor *= 0.85;
      return Math.max(0, Math.floor(rate * factor));
    }
    function summary(estimate) {
      return "Reference: " + sku + "\nDevice: " + [get("category").value, get("brand").value, get("model").value, get("storage").value].join(" / ") + "\nTurns on: " + selected("powers") + "\nNo cracks: " + selected("cracks") + "\nBattery 85%+: " + selected("battery") + "\nEstimate: " + (estimate != null ? formatMoney(estimate * 100) + " indicative, subject to inspection" : "Personal quote needed") + "\nPreference: " + get("payout").value + "\nCustomer trade-in estimate is not a guaranteed discount or payout.";
    }
    function updateEstimate() {
      var estimate = getEstimate();
      el.querySelector("[data-mz-estimate]").textContent = estimate != null ? formatMoney(estimate * 100) : "Personal quote required";
      el.querySelector("[data-mz-estimate-note]").textContent = estimate != null ? "Indicative trade-in value in USD. Final offer after inspecting the device." : "This model has no approved estimate rate yet. Send the details for a personal quote.";
      el.querySelector("[data-mz-sku]").textContent = sku;
      get("sku").value = sku;
      get("estimate").value = estimate != null ? String(estimate) + " USD (indicative)" : "Pending merchant inspection";
      get("summary").value = summary(estimate);
      var number = validWhatsApp(el.dataset.whatsapp);
      var link = el.querySelector("[data-mz-trade-whatsapp]");
      if (link && number) {
        link.hidden = false;
        link.href = whatsAppHref(number, "Hello MountZone, I'd like a trade-in quote.\n" + summary(estimate));
        link.dataset.mzPrepared = "true";
        try { sessionStorage.setItem("mz_trade_sku", sku); } catch (e) {}
      } else if (link) { link.hidden = true; }
      return estimate;
    }
    el.querySelectorAll("[data-mz-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (step === 0) {
          var values = ["category", "brand", "model", "storage"];
          var bad = values.map(get).find(function (input) { return !input || !input.value.trim(); });
          if (bad) { error("Please complete your device details."); if (bad) bad.focus(); return; }
        }
        if (step === 1 && ["powers", "cracks", "battery"].some(function (k) { return !selected(k); })) { error("Please answer all three condition questions."); return; }
        if (step === 1) updateEstimate();
        showStep(Math.min(2, step + 1));
      });
    });
    el.querySelectorAll("[data-mz-back]").forEach(function (button) { button.addEventListener("click", function () { showStep(Math.max(0, step - 1)); }); });
    if (get("payout")) get("payout").addEventListener("change", updateEstimate);
    if (form) form.addEventListener("submit", function (event) {
      if (step !== 2) { event.preventDefault(); showStep(2); return; }
      updateEstimate();
      var email = get("email");
      var name = get("name");
      if (!name.value.trim() || !email.validity.valid || !email.value.trim()) {
        event.preventDefault(); error("Please enter your name and valid email."); (name.value.trim() ? email : name).focus();
      }
    });
    var link = el.querySelector("[data-mz-trade-whatsapp]");
    if (link) link.hidden = true;
    showStep(0);
  }
  function setupGrading(el) {
    if (el.dataset.mzInitialized) return;
    el.dataset.mzInitialized = "1";
    var targetProductId = el.dataset.productId;
    var picker = Array.from(document.querySelectorAll("variant-picker")).find(function (p) { return p.dataset.productId === targetProductId; });
    var radioInputs = picker ? Array.from(picker.querySelectorAll('input[data-option-name], select')) : [];
    var gradeOption = (el.dataset.gradeOption || "").toLowerCase();
    var gradeInputs = radioInputs.filter(function (input) { return (input.dataset.optionName || "").toLowerCase() === gradeOption; });
    if (gradeInputs.length) gradeInputs.forEach(function (input) { var fieldset = input.closest("fieldset"); if (fieldset) fieldset.classList.add("mz-native-grade-hidden"); });
    var variants = [];
    try { variants = JSON.parse(el.querySelector("script[type='application/json']").textContent || "[]"); } catch (e) {}
    var buttons = Array.from(el.querySelectorAll("[data-mz-grade-button]"));
    var price = el.querySelector("[data-mz-grade-price]");
    var copy = el.querySelector("[data-mz-grade-copy]");
    var save = el.querySelector("[data-mz-save]");
    var form = Array.from(document.querySelectorAll("product-form-component")).find(function (f) { return f.dataset.productId === targetProductId; });
    var inputId = form ? form.querySelector('input[name="id"]') : null;
    function currentVariant() {
      var id = inputId ? String(inputId.value) : "";
      return variants.find(function (v) { return String(v.id) === id; }) || null;
    }
    function currentMatch(grade) {
      var selected = currentVariant();
      var otherOpts = selected && selected.options ? selected.options.slice() : [];
      var idx = Number(el.dataset.optionIndex);
      return variants.find(function (v) {
        if (!v.options || v.options[idx] !== grade) return false;
        return !otherOpts.length || v.options.every(function (value, i) { return i === idx || value === otherOpts[i]; });
      }) || variants.find(function (v) { return v.options && v.options[idx] === grade; }) || null;
    }
    function render(grade, variant) {
      var descriptions = {
        fair: "Visible cosmetic wear. Ask for photos and the per-device inspection report.",
        good: "Light cosmetic wear. Ask for real photos and verified device details.",
        excellent: "Near-mint appearance, subject to the exact listing photos and inspection.",
        "brand new (sealed)": "Sealed stock. Check the warranty terms on this exact listing."
      };
      buttons.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.grade === grade)); });
      price.textContent = variant ? formatMoney(variant.price) : "Select an available grade";
      copy.textContent = descriptions[(grade || "").toLowerCase()] || "Check this grade's exact listing details before ordering.";
      var sealed = currentMatch("Brand New (Sealed)");
      if (save) {
        var difference = sealed && variant ? sealed.price - variant.price : 0;
        save.hidden = !(difference > 0 && grade !== "Brand New (Sealed)");
        if (difference > 0) save.textContent = "Save " + formatMoney(difference) + " vs. sealed";
      }
    }
    buttons.forEach(function (b) { b.addEventListener("click", function () {
      var grade = b.dataset.grade;
      var gradeVariant = currentMatch(grade);
      if (!gradeVariant || !gradeVariant.available) return;
      var nativeInput = gradeInputs.find(function (i) { return i.value === grade; });
      if (nativeInput) { nativeInput.click(); nativeInput.dispatchEvent(new Event("change",{ bubbles:true })); }
      render(grade, gradeVariant);
      window.history.replaceState(window.history.state, "", el.dataset.productUrl + "?variant=" + gradeVariant.id);
      updateWhatsApp();
    }); });
    function updateWhatsApp() {
      var link = document.querySelector("[data-mz-product-whatsapp]");
      if (!link || link.dataset.productId !== targetProductId) return;
      var number = validWhatsApp(link.dataset.whatsapp);
      var variant = currentVariant();
      var grade = buttons.find(function (b) { return b.getAttribute("aria-pressed") === "true"; });
      if (!number) { link.hidden = true; return; }
      var sku = "";
      try { sku = sessionStorage.getItem("mz_trade_sku") || ""; } catch (e) {}
      var priceAmount = variant ? formatMoney(variant.price) : (price ? price.textContent : "");
      link.href = whatsAppHref(number, "Hello MountZone, I'd like to order / discuss:\nProduct: " + link.dataset.productTitle + "\nCondition: " + (grade ? grade.dataset.grade : "Not applicable") + "\nUSD price: " + priceAmount + "\nTrade-in reference: " + (sku || "Not provided") + "\nProduct: " + window.location.href);
      link.hidden = false;
    }
    if (picker) picker.addEventListener("change", function () {
      window.setTimeout(function () { var variant = currentVariant();if(variant){ var idx=Number(el.dataset.optionIndex);render(variant.options[idx],variant);}updateWhatsApp(); },250);
    });
    if (inputId && typeof MutationObserver !== "undefined") new MutationObserver(function () {
      var variant = currentVariant();
      if (variant) { var idx=Number(el.dataset.optionIndex); render(variant.options[idx],variant); }
      updateWhatsApp();
    }).observe(inputId, {attributes:true,attributeFilter:["value"]});
    var init = currentVariant();
    if (init) render(init.options[Number(el.dataset.optionIndex)],init);
    updateWhatsApp();
  }
  function setupProductWhatsApp() {
    document.querySelectorAll("[data-mz-product-whatsapp]").forEach(function (link) {
      if (link.closest("[data-mz-grade]")) return;
      var number = validWhatsApp(link.dataset.whatsapp);
      if (!number) { link.hidden = true; return; }
      var form = Array.from(document.querySelectorAll("product-form-component")).find(function (item) { return item.dataset.productId === link.dataset.productId; });
      var price = Number(link.dataset.priceCents);
      function sync() {
        var sku="";try{sku=sessionStorage.getItem("mz_trade_sku")||"";}catch(e){}
        link.href=whatsAppHref(number,"Hello MountZone, I'd like to order / discuss:\nProduct: "+link.dataset.productTitle+"\nCondition: "+(link.dataset.condition||"Not applicable")+"\nUSD price: "+formatMoney(price)+"\nTrade-in reference: "+(sku||"Not provided")+"\nProduct: "+window.location.href);
        link.hidden=false;
      }
      if(form)form.addEventListener("change",sync);
      sync();
    });
  }
  function init() {
    document.querySelectorAll("[data-mz-trade]").forEach(setupTrade);
    document.querySelectorAll("[data-mz-grade]").forEach(setupGrading);
    setupProductWhatsApp();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, {once:true}); else init();
  document.addEventListener("shopify:section:load", init);
})();
